
import React, { useState, useEffect, useContext } from 'react';
import { Alert, Typography, TextField, Button, Grid, Box } from '@mui/material';
import rnp from '../RNP/rnp.png'
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { ContextSession } from '../../services/ContextSession';
import { isSessionExpiredError, postHeader } from '../../services/http';
import FichaDni from '../RNP/fichadni.component';
import FichaPadre from './fichapadresdni.component';
import { rnpSubmitButtonSx } from './rnpButtonStyles';

async function getDniData(dni, justificacion, auto) {
  let json = { numinscripcion: dni, justificacion };
  let url = "";
  auto = "Bearer " + auto;
  //url = "http://172.20.7.21:8080/api/rnp/consulta/";
  url = "https://bei360.injupemp.gob.hn:8444/api/rnp/consulta/";

  //url="https://institutoalfonsohernandezcordova.com/Secretaria/Angular2/session.php";
  let datas = await postHeader(url, json, auto);

  return datas;
}

export default function RnpConsultas() {
  let sessi = useContext(ContextSession);
  let dnida = sessi.getVariable("dniData") || null;
  const [dniData, setDniData] = useState(dnida);
  const [dni, setDni] = useState('');
  const [justificacion, setJustificacion] = useState('');
  const [justificacionError, setJustificacionError] = useState(false);
  const [requestError, setRequestError] = useState('');
  const [mostrarPadres, setMostrarPadres] = useState(false);
  const [padres, setPadres] = useState(sessi.getVariable("dniPadres"))
  const [isLoading, setIsLoading] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      sessi.setVariable("dniData", null);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Determinar qué ancho utilizar basado en el ancho de la ventana
  const getWidth = () => {
    if (windowWidth <= 600) {
      return '300px'; // Dispositivos móviles
    } else {
      return '600px'; // Computadoras
    }
  };

  const handleMostrarPadres = () => {
    setMostrarPadres((mostrarPadres) => !mostrarPadres);
  }
  const handleDniChange = (event) => {
    let inputDni = event.target.value.replace(/\D/g, ''); // Elimina todos los caracteres que no sean números

    if (inputDni.length > 0) {
      let formattedDni = '';
      // Formato XXXX/XXXX/XXXXX
      formattedDni += inputDni.slice(0, 4);
      if (inputDni.length > 4) formattedDni += '-' + inputDni.slice(4, 8);
      if (inputDni.length > 8) formattedDni += '-' + inputDni.slice(8, 13);

      setDni(formattedDni);
    } else {
      setDni('');
    }
  };

  const handleJustificacionChange = (event) => {
    const value = event.target.value.slice(0, 100);
    setJustificacion(value);
    if (justificacionError && value.trim()) {
      setJustificacionError(false);
    }
  };

  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&::before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      '&::after': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
  }));
  function convertPadres(data) {
    data = data.replaceAll("0:0", ".");
    data = data.replaceAll(', ', ',');
    data = data.replaceAll(': ', ':');
    data = data.replaceAll(',', '","');
    data = data.replaceAll(':', '":"');
    data = '{"' + data + '"}';
    return data;
  }
  async function handleConsultar() {
    const justificacionLimpia = justificacion.trim();

    if (!justificacionLimpia) {
      setJustificacionError(true);
      return;
    }

    if (dni.length >= 15) {
      setIsLoading(true); // Mostrar CircularProgress
      setRequestError('');
      setDniData(null);
      sessi.setVariable("dniData", null);

      try {
        let id = dni.replaceAll("-", "");
        let token = sessi.sessionData.token;
        let dnidata = await getDniData(id, justificacionLimpia, token)
        let padre, madre;
        //console.log("DNIDATA DEF", dnidata);
        if (dnidata.padre) {
          padre = dnidata.padre.toLowerCase();
          padre = JSON.parse(convertPadres(padre))
        }
        if (dnidata.madre) {
          madre = dnidata.madre.toLowerCase();
          madre = JSON.parse(convertPadres(madre));
        }

        setPadres(() => { return { madre: madre, padre: padre } });
        sessi.setVariable("dniPadres", { madre: madre, padre: padre });
        setDniData(() => dnidata);

        sessi.setVariable("dniData", dnidata);
      } catch (error) {
        if (isSessionExpiredError(error)) {
          return;
        }
        console.error("Error consultando RNP:", error);
        setRequestError(error.message || "No se pudo completar la consulta al RNP.");
      } finally {
        setIsLoading(false); // Ocultar CircularProgress
      }
    }
  }

  return (

    <Grid container direction="column" alignItems="center" spacing={2}>

      <Grid item marginTop={3}>
        <Typography variant="h3">Consultas RNP</Typography>
      </Grid>
      <Grid item container alignItems="center" justifyContent="center" spacing={2}>
        <Grid item>
          <Typography variant="body1">
            <img src={rnp} alt="RNP Logo" height="70" />
          </Typography>
        </Grid>
        <Grid item>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                fullWidth
                id="dni-input"
                label="DNI"
                variant="outlined"
                value={dni}
                onChange={handleDniChange}
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} // Permitir solo números
                style={{ width: getWidth() }} // Establecer el ancho dinámicamente
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                multiline
                minRows={2}
                maxRows={3}
                id="justificacion-input"
                label="Justificación breve"
                variant="outlined"
                value={justificacion}
                onChange={handleJustificacionChange}
                inputProps={{ maxLength: 100 }}
                error={justificacionError}
                helperText={justificacionError ? 'Debe indicar la justificación de la consulta.' : `Motivo laboral de la consulta. ${justificacion.length}/100`}
                style={{ width: getWidth() }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button
            onClick={handleConsultar}
            disabled={dni.length !== 15 || !justificacion.trim() || isLoading}
            variant="contained"
            sx={rnpSubmitButtonSx}
          >
            Enviar
          </Button>
        </Grid>
      </Grid>

      <Grid item>{isLoading && <CircularProgress color="success" />} {/* Mostrar CircularProgress si isLoading es true */}</Grid>
      <Grid item>
        {isLoading && <Typography>Cargando...</Typography>}
      </Grid>
      <Grid item>
        {requestError && <Alert severity="warning">{requestError}</Alert>}
      </Grid>
      {((dniData != null)) && (<Grid>
        <Box>
          <FichaDni dniData={dniData} />

          {(mostrarPadres && padres.madre != undefined) && <FichaPadre padreData={padres} />}
          <Grid item>
            <FormControlLabel
              control={<Android12Switch checked={mostrarPadres} onClick={handleMostrarPadres} color='success' />}
              label="Mostrar Datos De Los Padres"
            />
          </Grid>
        </Box>

      </Grid>)}

    </Grid>

  );
}

